<template>
  <v-card variant="outlined" class="mb-2">
    <v-card-text class="pa-3">
      <div class="d-flex justify-space-between align-center mb-1">
        <router-link
          :to="getAccountRoute({ name: 'pipeline', params: { id: item._key }})"
          class="text-decoration-none"
        >
          <strong class="text-primary text-body-1">{{ item.deal_name || item.name }}</strong>
        </router-link>
      </div>

      <v-list density="compact" class="pa-0">
        <v-list-item v-if="item.stage" class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-chart-timeline-variant</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">{{ item.stage }}</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item v-if="item.size" class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-ruler-square</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">{{ formattedSize }}</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item v-if="item.consideration" class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-currency-usd</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">{{ formattedConsideration }}</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item v-if="item.days_open" class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-calendar-clock</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">{{ daysOpenText }}</v-list-item-title>
          </div>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { IAiPipelineResult } from '@/bundles/AiAgent/types';
import { formatNumber, formatCurrency } from '@/utils/filters';

export default defineComponent({
  name: 'PipelineCard',
  mixins: [AccountLayoutMixin],

  props: {
    item: {
      type: Object as PropType<IAiPipelineResult>,
      required: true,
    },
  },

  computed: {
    formattedSize (): string {
      if (!this.item.size) return 'N/A';
      return `${formatNumber(this.item.size)} SF`;
    },

    formattedConsideration (): string {
      if (!this.item.consideration) return 'N/A';
      return formatCurrency(this.item.consideration);
    },

    daysOpenText (): string {
      const days = this.item.days_open;
      if (!days) return 'N/A';
      return days === 1 ? '1 day open' : `${days} days open`;
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-list-item__prepend) {
  align-self: center !important;
}
</style>
